// Mounted inside <BrowserRouter> to fire page-view events on every route change.
import { usePageViewTracker } from "../lib/analytics";

export default function AnalyticsBootstrap() {
  usePageViewTracker();
  return null;
}
